import DataTable from 'components/datatable';
import Error from 'components/Error';
import Spinner from 'components/Spinner';
import WizardActions from 'components/WizardActions';
import PropTypes from 'prop-types';
import React from 'react';
import Search from '../search';

const Lessons = ({error, lessons, lessonType, nextFn, nextDisabled, loading, loadingApplicants, searchType, searchFn, updateSearchTerms, searchTerms, showProColumns}) => {
  return (
    <div>
      <Search searchType={searchType}
              searchFn={searchFn}
              updateSearchTerms={updateSearchTerms}
              lessonType={lessonType}
              searchTerms={searchTerms}
               />
      {loading && !error && <Spinner />}
      {error && !loading && <Error message={error.message} />}
      {!!lessons && !loading && !error &&
        <DataTable tableType='THEORY_LESSONS' rows={lessons} rowKey='lessonId' showProColumns={ showProColumns}/>
      }
      <WizardActions loading={loadingApplicants} nextDisabled={nextDisabled} nextFn={nextFn} />
    </div>
  );
};

Lessons.propTypes = {
  error: PropTypes.object,
  lessons: PropTypes.array,
  lessonType: PropTypes.string,
  nextFn: PropTypes.func,
  nextDisabled: PropTypes.bool,
  searchFn: PropTypes.func,
  updateSearchTerms: PropTypes.func,
  searchTerms: PropTypes.object,
  loading: PropTypes.bool,
  loadingApplicants: PropTypes.bool,
  searchType: PropTypes.string,
  showProColumns: PropTypes.bool,
};

export default Lessons;


// WEBPACK FOOTER //
// ./src/containers/theory/Lessons.jsx